module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "moral"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Moral')))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [(_vm.isSystemManagement) ? _c('div', {
    staticClass: "col-sm-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-warning btn-lg btn-menu",
    attrs: {
      "to": "/moral_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Moral List')))])])], 1) : _vm._e(), _c('div', {
    staticClass: "col-sm-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/moral_result_list"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Moral Result List')))])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-85640c56!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/moral.pug
// module id = 864
// module chunks = 1